export * from './src/pwa.installer';